import styled from 'styled-components';
import { MediaQuery, Size } from '../../constant/breakpoint.ts';

export const Section = styled('div')({
    padding: "64px 32px 64px 32px",
    display: "flex",
    justifyContent: "center",
    alignItems: 'center',
    position: "relative",
    width: 'auto',
    marginTop: "100px",
    [MediaQuery[Size.LG]]: {
      padding: "64px 32px 64px 32px",
    },
    [MediaQuery[Size.MD]]: {
      padding: "64px 16px 64px 16px",
    },
    [MediaQuery[Size.SM]]: {
      padding: "32px 8px 32px 8px",
    },
})

export const ImageWrapper = styled('div')({
  display: "flex",
  justifyContent: "center",
  zIndex: 3,
  width: "100%",
  height: 'auto'
})

export const Image = styled('img')({
  width: '100%',
  height: 'auto',
  borderRadius: '45px',
  objectFit: 'cover',
  [MediaQuery[Size.XL]]: {
    width: '100%',
  },
})

export const BottomRightDiv = styled('div')((props) => ({
  position: "absolute",
  bottom: "16px",
  right: "2%",
  backgroundColor: "white",
  color: "#A0865B",
  borderRadius: "30px",
  width: "568px",
  paddingLeft: "40px",
  paddingRight: "40px",
  paddingBottom: "10px",
  paddingTop: "20px",
  fontWeight: 400,
  fontSize: "30px",
  zIndex: 4,
  fontFamily: "Gotham",
  height: "auto",
  ...(props.addFullGrey && {
    backgroundColor: "#EDEDED",
  }),

  ...(props.caption === "YOUR SUPREME LEGAL PROTECTION" && {
    width: "662px",
    bottom: "56px",
    right: "3%",
  }),

  [MediaQuery[Size.XL]]: {
    fontSize: "24px",
    right: "2%",
    width: "398px",

    ...(props.caption === "YOUR SUPREME LEGAL PROTECTION" && {
      width: "562px",
      bottom: "72px",
      right: "4%",
    }),
  },

  [MediaQuery[Size.MD]]: {
    bottom: "40px",
    right: "0px",
    paddingLeft: "28px",
    paddingRight: "28px",
    paddingBottom: "10px",
    paddingTop: "20px",
    fontSize: "18px",
    width: "308px",
    borderRadius: "20px",

    ...(props.caption === "YOUR SUPREME LEGAL PROTECTION" && {
      width: "442px",
      bottom: "72px",
      right: "4%",
    }),
  },

  [MediaQuery[Size.SM]]: {
    bottom: "16px",
    right: "0px",
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingTop: "15px",
    paddingBottom: "7px",
    fontSize: "16px",
    lineHeight: "24px",
    width: "248px",
    borderRadius: "16px",

    ...(props.caption === "YOUR SUPREME LEGAL PROTECTION" && {
      width: "362px",
      bottom: "48px",
      right: "4%",
    }),
  },
})); 

export const BgLine = styled('div')(props => ({
  zIndex: 1,
  backgroundColor: "#EDEDED",
  position: "absolute",
  bottom: "120px",
  height: "60%",
  color: "#A0865B",
  width: "100%",
  fontWeight: 600,
  fontSize: "30px",
  
}))

export const BgFullGreyLine = styled('div')({
  zIndex: 1,
  backgroundColor: "#EDEDED",
  position: "absolute",
  bottom: "0",
  height: "70%",
  color: "#A0865B",
  width: "100%",
  fontWeight: 600,
})
